import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProgramService } from '../../../../services/program.service';
import { TryoutProgramService } from '../../../../services/tryout_Services/tryout-program.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';
import { LeftNavigationService } from '../../../../services/left-navigation.service';
import { Subscription } from 'rxjs/Subscription';
import { TokenService } from '../../../../services/token.service';
import { AppState, Store, AppTypes, AppFields, ProgramsBillingType, AutoUnsubscribe, filter, take, EStaffRoles, StorageUtil } from '../../../../store/app.models';
import { UserInfo } from '../../../../interfaces';

@Component({
  selector: 'app-tryout-program-read',
  templateUrl: './tryout-program-read.component.html',
  styleUrls: ['./tryout-program-read.component.css']
})
@AutoUnsubscribe
export class TryoutProgramReadComponent implements OnInit {
  public tryoutPrograms = [];
  public names: any;
  public selectedAll: any;
  public selectedRecordIndex = [];
  public isSelectAllCheckBox = false;
  public isCheckAllCheckBox = false;
  public program_status = '1';
  public NoOfActiveBillingPrograms: number;
  public NoOfInactiveBillingPrograms: number;
  public NoOfArchiveBillingPrograms: number;
  public NoOfSelectedProgram: number;
  public isOpenConfirmDeletePopup = false;
  public currentUrl = '';
  public routeParams;
  public popupConfirmForm: FormGroup;
  public alphaNumericPattern = /^[a-zA-Z ]+$/;
  public isConfirmWarning = false;
  public PageHeaderName: string;

  public clubId = 0;
  public tokenValue = '';
  public teamId = '';

  loadingIndicator = true; // ngx-datatable
  rows = [];
  columns = [
    { name: 'clubProgramID' },
    { prop: 'programName' },
    { name: 'currentParticipants' },
    { name: 'amountCollected' },
    { name: 'amountOutStanding' },
    { name: 'regStatus' },
    { name: 'programStatus' },
    { name: 'clubProgramID' },
  ];
  sub: Subscription;

  constructor(private fb: FormBuilder,
    private notificationsService: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private programService: ProgramService,
    private tryoutProgramService: TryoutProgramService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private leftNavigationService: LeftNavigationService,
    private tokenService: TokenService,
    private store: Store<AppState>
  ) {
    this.clearHeaderName();

    this.store.dispatch({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.BillingTypeID]: ProgramsBillingType.TryoutBilling
      }
    });
  }

  ngOnInit() {
    /* Fixed: same page refresh content. (tempory archive) */
    this.router.routeReuseStrategy.shouldReuseRoute = function (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) {
      return false;
    };

    this.routeParams = this.activeRoute.snapshot.params;

    const status = this.routeParams.status;
    if (status === 'inactive') {
      this.program_status = '0';
    } else if (status === 'active') {
      this.program_status = '1';
    } else if (status === 'archive') {
      this.program_status = '2';
    }

    // Set clubId and tokenValue to localStorage
    if (this.routeParams.clubId !== undefined) {
      localStorage.setItem('clubId', this.routeParams.clubId);
      localStorage.setItem('tokenValue', decodeURIComponent(this.routeParams.tokenValue));
    } else {
        this.clubId = +localStorage.getItem('clubId');
        this.tokenValue = localStorage.getItem('tokenValue');
        this.teamId = localStorage.getItem('teamId');
    }

    this.store.dispatch({
      type: AppTypes.InitializeClub,
      payload: {
        clubId: +this.clubId
      }
    });

    const tokenData = {
      clubId: +this.clubId,
      tokenValue: this.tokenValue,
      teamId: this.teamId || null
    };

    // this.tokenService.validateTeamUser(tokenData).subscribe((userId) => {
    //   if (userId === 0) {
    //     this.router.navigate(['/401/']);
    //   } else {
    //     localStorage.setItem('userId', userId.toString());
    //   }
    // });

    this.sub = this.store.select(AppFields.App, AppFields.User).subscribe((u: UserInfo) => {
      if (u === null) {
        this.store.dispatch({
          type: AppTypes.ValidateUser,
          payload: tokenData
        });
      } else {
        this.getPageHeaderName();
        this.getBillingProgramCounter();
        this.filterPrograms(this.program_status);
      }
    });

    this.popupConfirmForm = this.fb.group({
      confirm_program_delete: [null]
    });
  }

  getBillingProgramCounter() {
    this.store.select(AppFields.App, AppFields.MyTeam).pipe(take(1)).subscribe(
      team => {
        this.tryoutProgramService.getTryoutProgramCounts('2', this.clubId, team ? team.teamID : 0).subscribe(rs => {
          this.NoOfActiveBillingPrograms = rs[0].programActive;
          this.NoOfInactiveBillingPrograms = rs[0].programInActive;
          this.NoOfArchiveBillingPrograms = rs[0].programArchive;
        });
      }
    );
  }

  clearHeaderName() {
    const routeObj = { 'Slug': '', 'ClubProgramID': '', 'ClubProgramName': '', 'Status': '', 'ClubProgramTypeID': '' };
    localStorage.setItem('routeObject', JSON.stringify(routeObj));
  }

  /* Set Page Header. */
  getPageHeaderName(clubProgramTypeID?: number, name?: string) {
    // this.subscription = this.leftNavigationService.getLeftNav().subscribe((navObject: any) => {
    //  console.log(navObject.ProgramNam);
    //  if (navObject.ProgramName !== 'undefined') {
    //    this.PageHeaderName = navObject.ProgramName;
    //  } else {
    //    this.PageHeaderName = '';
    //  }
    // });

    // if (name !== undefined) {
    //  this.PageHeaderName = name;
    // } else {
    //  this.PageHeaderName = '';
    // }

    if (clubProgramTypeID === 1) {
      this.PageHeaderName = 'Club Billing - ' + name;
    } else if (clubProgramTypeID === 2) {
      this.PageHeaderName = 'Tryout - ' + name;
    } else if (clubProgramTypeID === 3) {
      this.PageHeaderName = 'Team Travel - ' + name;
    } else if (clubProgramTypeID === 4) {
      this.PageHeaderName = 'Camps / Clinics - ' + name;
    } else if (clubProgramTypeID === 5) {
      this.PageHeaderName = 'Fundraising - ' + name;
    } else if (clubProgramTypeID === 6) {
      this.PageHeaderName = 'All In Program - ' + name;
    } else {
      this.PageHeaderName = '';
    }
  }

  slugText(str) {
    return str.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, ' ').replace(/[\s-]+/g, '-');
  }

  /**
   * Set Left Navigation Properties.
   *
   * @param clubProgramID
   * @param programName
   * @param programStatus
   * @param clubProgramTypeID
   */
  openLeftNavigation(clubProgramID, programName, programStatus, clubProgramTypeID) {
    this.getPageHeaderName(clubProgramTypeID, programName);

    this.store.dispatch({
      type: AppTypes.InitializeProgram,
      payload: {
        programId: clubProgramID
      }
    });

    this.store.select(AppFields.App, AppFields.User).pipe(take(1)).subscribe((user: UserInfo) => {
      const url = (user.userRoles.indexOf(EStaffRoles.TeamAdmin) > -1 || user.userRoles.indexOf(EStaffRoles.ClubDirector) > -1
          || user.userRoles.indexOf(EStaffRoles.ClubRegistrar) > -1) && this.clubId > 0
        ? '/tryoutprogram/tryout-program/' + clubProgramID
        : '/tryoutmembers/' + this.slugText(programName) + '/' + clubProgramID + '/registered';
        console.log(url);
      this.router.navigate([url]).then(nav => {
        console.log(nav);
        /* Page Header */
        const routeObj = {
          'Slug': this.slugText(programName),
          'ClubProgramID': clubProgramID,
          'ClubProgramName': programName,
          'Status': status,
          'ClubProgramTypeID': clubProgramTypeID
        };
        localStorage.setItem('routeObject', JSON.stringify(routeObj));
        this.leftNavigationService.setLeftNav(clubProgramID, clubProgramTypeID, programName, programStatus);
      }, err => {
        console.log(err); // when there's an error
      });
    });

  }


  /* Go to edit a program page. */
  editProgramForm(clubProgramID, programName, programStatus, clubProgramTypeID) {
    this.getPageHeaderName(clubProgramTypeID, programName);
    // this.leftNavigationService.setLeftNav(clubProgramID, clubProgramTypeID, programName, programStatus);
    this.router.navigate(['/tryoutprogram/tryout-program/' + clubProgramID]);
  }

  selectedRecord(i, e) {
    if (e.target.checked) {
      this.selectedRecordIndex.push(i);
    } else {
      this.selectedRecordIndex.splice(this.selectedRecordIndex.indexOf(i), 1);
    }
    // For enable status/delete button.
    this.NoOfSelectedProgram = this.selectedRecordIndex.length;
  }

  selectAll() {
    if (this.isSelectAllCheckBox) {
      this.isSelectAllCheckBox = false;
      this.isCheckAllCheckBox = false;
      this.selectedRecordIndex.length = 0;
    } else {
      this.isSelectAllCheckBox = true;
      this.isCheckAllCheckBox = true;
      const l = this.tryoutPrograms.length;
      for (let i = 0; i < l; i++) {
        this.selectedRecordIndex.push(this.tryoutPrograms[i].clubProgramID);
      }
    }
    // For enable status/delete button.
    this.NoOfSelectedProgram = this.selectedRecordIndex.length;
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.success(status, message, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }

  deleteSelectedProgramRecords() {
    this.openPopup();
  }

  addConfirmFormValidation() {
    const control = this.popupConfirmForm.get('confirm_program_delete');
    control.setValidators(Validators.compose([Validators.required, Validators.pattern(this.alphaNumericPattern)]));
    control.updateValueAndValidity();
  }
  removeConfirmFormValidation() {
    const control = this.popupConfirmForm.get('confirm_program_delete');
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }

  openPopup() {
    this.isOpenConfirmDeletePopup = true;
    this.addConfirmFormValidation();
  }

  closePopup() {
    this.isOpenConfirmDeletePopup = false;
    this.isConfirmWarning = false;
    this.popupConfirmForm.reset();
    this.removeConfirmFormValidation();
  }

  onPopUpConfirm(formValue) {
    const flag = this.isDeleteTextMatched();
    if (flag) {
      this.isConfirmWarning = false;
      this.closePopup();
      this.deletePrograms();
    } else {
      this.isConfirmWarning = true;
    }
  }

  isDeleteTextMatched() {
    const val = this.popupConfirmForm.get('confirm_program_delete').value;
    if (val) {
      return (val.trim() === 'DELETE') ? true : false;
    }
  }

  isConfirmDeleteValid() {
    return this.popupConfirmForm.get('confirm_program_delete').errors
      && (this.popupConfirmForm.get('confirm_program_delete').touched
        || this.popupConfirmForm.get('confirm_program_delete').dirty);
  }

  validateUi() {
    Object.keys(this.popupConfirmForm.controls).forEach(field => {
      const control = this.popupConfirmForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  removeValidaion(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }

  requiredValidaion(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.enable();
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }

  deletePrograms() {
    const l = this.selectedRecordIndex.length;
    const ids = this.selectedRecordIndex.join(', ');
    this.spinnerService.show();
    this.programService.deletePrograms(ids).subscribe((data) => {
      this.NoOfSelectedProgram = 0; // Hide status and delete button.
      this.selectedRecordIndex.length = 0;
      this.isSelectAllCheckBox = false;
      this.isCheckAllCheckBox = false;
      this.removeValidaion('confirm_program_delete');
      this.closePopup();
      this.refreshReocrds();
      setTimeout(() => {
        if (l === 1) {
          this.alertMessage('success', 'A Program successfully deleted.');
        } else {
          this.alertMessage('success', 'Programs successfully deleted.');
        }
      }, 1000);
    }, error => {
      console.log(error);
    });
  }

  filterPrograms(status) {
    this.spinnerService.show();
    this.store.select(AppFields.App, AppFields.MyTeam).pipe(take(1)).subscribe(
      team => {
        this.tryoutProgramService.getTryoutProgramsByStatus(status, '2', this.clubId, team ? team.teamID : 0).subscribe(rs => {
          this.tryoutPrograms = rs;
          this.rows = rs;
          this.loadingIndicator = false; // ngx-datatable
          this.program_status = status;
          let s = '';
          if (this.program_status === '0') {
            s = 'inactive';
          } else if (this.program_status === '1') {
            s = 'active';
          } else if (this.program_status === '2') {
            s = 'archive';
          }
          this.spinnerService.hide();
          /* Fixed: same page refresh content. */
          this.router.navigateByUrl('tryoutprogram/' + s);
        });
      }
    );
  }

  changeProgramStatus(status) {
    const obj = {
      'ProgramIds': this.selectedRecordIndex,
      'ProgramStatus': status
    };
    this.spinnerService.show();
    this.programService.changeStatus(obj).subscribe((data) => {
      this.alertMessage('success', 'Program status changed.');
      this.NoOfSelectedProgram = 0;
      this.selectedRecordIndex.length = 0;
      this.program_status = status;
      this.refreshReocrds();
      this.spinnerService.hide();
      this.isSelectAllCheckBox = false;
      this.isCheckAllCheckBox = false;
    }, error => {
      console.log(error);
    });
  }

  refreshReocrds() {
    this.getBillingProgramCounter();
    this.filterPrograms(this.program_status);
  }

  get isTeamAccount(): boolean {
    return !StorageUtil.clubID;
  }
}

export interface TokenValidationData {
    clubId: string;
    tokenValue: string;
}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-programs/tryout-program-read/tryout-program-read.component.ts